import {EventEmitter, Injectable} from '@angular/core';
import {AsgardPane} from 'src/models/AsgardPane';
import {BehaviorSubject, Observable} from 'rxjs';
import {DeviceDetectorService} from './device-detector.service';
import {DeviceTypes} from 'src/models/DeviceTypes';

@Injectable({
  providedIn: 'root'
})
export class PaneService {

  private currentPanes: AsgardPane[] = [];
  private paneLimit: number;
  private limitPanesReached: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private activePaneIndex: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  HideTogglePanes: BehaviorSubject<boolean> = new BehaviorSubject(false);
  ChangePandeIndexForTabsEv: EventEmitter<boolean> = new EventEmitter();
  PaneIndexChanged: EventEmitter<boolean> = new EventEmitter();
  paneToggled: EventEmitter<boolean> = new EventEmitter();

  get isDoublePanes():boolean {
    return this.currentPanes.length > 1;
  }

  constructor(
    private deviceDetectorService: DeviceDetectorService,
  ) {
    this.onChangeDeviceTypeMobile();
    this.addPane();
  }

  checkPanesOnInit(): void {
    // after the user logs out, the pane list is destroyed and the 'cleanOndestroy' is called
    // if the user does not refresh and logs back in again using the same or a different account
    // then the constructor is not triggered and the pane list is empty
    // if that is the case, add one again
    if (this.currentPanes.length === 0) {
      this.addPane();
    }
  }

  setActivePaneIndex(indx: number) {
    if (indx !== this.getActivePaneIndex()) {
      this.activePaneIndex.next(indx);
    }
  }

  togglePanes() {
    const limitNotReached = this.currentPanes.length < this.paneLimit;
    if (limitNotReached) {
      this.addPane();
      this.limitPanesReached.next(true);

      this.paneToggled.emit(true);
    } else {
      this.ChangePandeIndexForTabsEv.emit(true);
      this.paneToggled.emit(true);
    }
  }

  destroyPane() {
    this.currentPanes.splice(1, 1);
    this.limitPanesReached.next(false);
    this.setActivePaneIndex(0);
  }

  getActivePaneObservable(): Observable<number> {
    return this.activePaneIndex.asObservable();
  }

  getActivePaneIndex(): number {
    return this.activePaneIndex.getValue();
  }

  getPanesLimit(): Observable<boolean> {
    return this.limitPanesReached.asObservable();
  }

  cleanOndestroy() {
    this.currentPanes = [];
    this.limitPanesReached.next(false);
    this.activePaneIndex.next(0);
  }

  private onChangeDeviceTypeMobile() {
    this.deviceDetectorService.deviceType$.subscribe((e: DeviceTypes) => {
      if (e === DeviceTypes.DESKTOP) {
        this.onDesktopAndTablet();
      } else {
        this.onMobileAndTablet();
      }
    });
  }

  private onMobileAndTablet() {
    this.paneLimit = 1;
    // if we have 2 panes open destroy last one
    if (this.currentPanes.length > this.paneLimit) {
      this.togglePanes();
    }
    this.HideTogglePanes.next(true);
  }

  private onDesktopAndTablet() {
    this.paneLimit = 2;
    this.HideTogglePanes.next(false);
  }

  private addPane(): void {
    const nextPaneIndex = this.currentPanes.length;
    this.currentPanes.forEach(i => i.isActive = false);
    const paneData = new AsgardPane(nextPaneIndex);
    this.currentPanes.push(paneData);
  }
}
